import { ContactsUpdatePrompt } from "./ContactsUpdatePrompt.mjs";
export {
  ContactsUpdatePrompt
};
